export function mapToArray (records) {
  const array = Array.from(records, function (value, key) {
    // Return the value of the Map record
    return value[1]
  })
  return array
}
